import {useAnswers, useDispatch, useNeuroMessages, useNeuroState, usePages} from "@ignitesales/neuro-application";
import {setContactPageState} from "../state/DialogueActions.mjs";

/**
 * @typedef DialogueContextHookValues
 * @property {Function} getPagePathMessageId - returns page or path message ID based on current survey page
 * @property {function(isActive:boolean, isClosable?:boolean|null)} updateContactPageState - update the contact page state in dialogue theme container
 * @property {boolean} contactPageIsActive - true if contact page state is active
 * @property {boolean} contactPageIsClosable - true if contact page is closable
 * @property {boolean} contactFormCompleted - true if contact page has been sent
 */

/**
 * Dialogue tools to help utilize common context / concepts needed in the themes
 * @returns {DialogueContextHookValues}
 */
const useDialogueContext = () => {
    const appDispatch = useDispatch();
    const { contactPageIsActive, contactFormCompleted: hasCompletedContact } = useNeuroState();
    const { hasAnswer } = useAnswers();
    const { getCurrentPage } = usePages();
    const { hasMessage } = useNeuroMessages();

    //TODO: load this information during init process
    const hasLeadTransmittedAnswer = hasAnswer('leadTransmitted');
    const hasContactFormCompletedAnswer = hasAnswer('hasCompletedContactForm');
    const contactFormCompleted = hasCompletedContact || hasLeadTransmittedAnswer || hasContactFormCompletedAnswer;

    const currentPage = getCurrentPage();
    const getPagePathMessageId = () => {
        const pathKey = currentPage?.path?.key;
        const pageKey = currentPage?.page?.key;
        const pageMessageId = `sidebar.${pathKey}.${pageKey}.text`;
        const pathMessageId = `sidebar.${pathKey}.text`;
        return hasMessage(pageMessageId) ? pageMessageId : pathMessageId;
    };

    const updateContactPageState = (isActive) => {
        appDispatch( setContactPageState({ isActive }) );
    };

    return {
        contactPageIsActive: contactPageIsActive !== undefined ? contactPageIsActive : !contactFormCompleted,
        contactPageIsClosable: true, //TODO: this should be configurable if guide is using a pre-summary contact page (i.e. shouldEnforceContact)
        contactFormCompleted,
        getPagePathMessageId,
        updateContactPageState
    };
};

export { useDialogueContext };
